// extracted by mini-css-extract-plugin
module.exports = {"bannerImage":"TourImage_bannerImage__LILK7","noBorder":"TourImage_noBorder__3JWVZ"};